import { Grid } from "@mui/material";
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';


const styles = {
    dimensionContainer: {
        border: 1,
        display: 'inline-flex',
        borderRadius: '5px',
        borderColor: '#D3D3DE',
        transition: 'background-color 120ms ease-in-out',
        '@keyframes certificationGridFlash': {
            '0%': {
                backgroundColor: '#FFF5B1'
            },
            '100%': {
                backgroundColor: 'transparent'
            }
        }
    },
    dimensionContainerFlashing: {
        animation: 'certificationGridFlash 600ms ease-in-out 0s 3'
    }
}

export default function CertificationDimensionGrid(props: any) {
    const { certificationResponse, flashCertificationGrid } = props;
    const { t } = useTranslation();
    const [isFlashing, setIsFlashing] = useState<boolean>(false);

    const units = certificationResponse?.Units?.LengthUnits || '';

    useEffect(() => {
        if (!flashCertificationGrid) {
            return;
        }

        setIsFlashing(true);
        const timeoutId = setTimeout(() => {
            setIsFlashing(false);
        }, 2000);

        return () => clearTimeout(timeoutId);
    }, [flashCertificationGrid]);

    return (
        <Grid container sx={{ ...styles.dimensionContainer, ...(isFlashing ? styles.dimensionContainerFlashing : {}) }} >
            <Grid item xs={3} >
            </Grid>
            <Grid item xs={3} fontStyle="italic">
                {t('control.certification.minimum')}
            </Grid>
            <Grid item xs={3} fontStyle="italic">
                {t('control.certification.maximum')}
            </Grid>
            <Grid item xs={3} fontStyle="italic">
                {t('control.certification.divisions')}
            </Grid>
            <Grid item xs={3} sx={{ pl: 2 }} fontStyle="italic">
                {t('control.certification.length')}
            </Grid>
            <Grid item xs={3}>
                {certificationResponse['LengthBounds'][0]} {units}
            </Grid>
            <Grid item xs={3}>
                {certificationResponse['LengthBounds'][1]} {units}
            </Grid>
            <Grid item xs={3}>
                {certificationResponse['Precision']} {units}
            </Grid>
            <Grid item xs={3} sx={{ pl: 2 }} fontStyle="italic">
                {t('control.certification.width')}
            </Grid>
            <Grid item xs={3}>
                {certificationResponse['WidthBounds'][0]} {units}
            </Grid>
            <Grid item xs={3}>
                {certificationResponse['WidthBounds'][1]} {units}
            </Grid>
            <Grid item xs={3}>
                {certificationResponse['Precision']} {units}
            </Grid>
            <Grid item xs={3} sx={{ pl: 2 }} fontStyle="italic">
                {t('control.certification.height')}
            </Grid>
            <Grid item xs={3}>
                {certificationResponse['HeightBounds'][0]} {units}
            </Grid>
            <Grid item xs={3}>
                {certificationResponse['HeightBounds'][1]} {units}
            </Grid>
            <Grid item xs={3}>
                {certificationResponse['Precision']} {units}
            </Grid>
        </Grid> 
    )
}